<template>
    <div v-if="data" class="company-info__group">
      <div class="company-info__group-title">{{$tCompany('Branches')}}</div>

        <div class="company-info__inner">

          <Editor v-model="data.address"
                  @input="$emit('change')"
                  class="translate-field__input"/>
        </div>
    </div>
</template>

<script>
  const Editor = () => import(
      /* webpackChunkName: "editor" */ './Editor'
      );
    import employerFormFields from '../mixins/employerFormFields';

    export default {
        name: "EmployerProfileBranches",
        mixins: [ employerFormFields ],
        components: {
          Editor
        },
    }
</script>

<style scoped>

</style>
